/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import React from "react";
import { Button, Grid, TextField } from "@material-ui/core";
import { FormInputLabel } from "../components/common/FormInputLabel";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useResendForm } from "./../hooks/use-resend-form";

import { CheckCircleOutlined } from "@material-ui/icons";
import { useState } from "react";
import { green } from "@material-ui/core/colors";
import { Box } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
const schema = yup.object().shape({
  orderNumber: yup.string().required("Campo requerido"),
});

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const ResendXml = () => {
  let query = useQuery();
  const { submitResendForm, showMessage, setShowMessage } = useResendForm();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmitHandler = (data: any) => {
    submitResendForm(data);
  };

  useEffect(() => {
    console.log(showMessage);
  }, [showMessage]);

  return (
    <>
      {showMessage && (
        <Grid
          container
          spacing={4}
          direction="column"
          alignItems="center"
          justify="center"
          style={{ minHeight: "40vh" }}>
          <CheckCircleOutlined style={{ color: green[500] }} fontSize="large" />
          <Typography variant="subtitle2">
            Solicitud enviada exitosamente
          </Typography>
          <Typography
            color="primary"
            variant="button"
            onClick={() => {
              setShowMessage(!showMessage);
            }}>
            <u className="pointer"> Hacer otra solicitud</u>
          </Typography>
        </Grid>
      )}
      {!showMessage && (
        <Grid
          container
          direction={"column"}
          alignItems="stretch"
          xs={12}
          md={4}>
          <Grid item xs={12}>
            <h3>Completa el campo para solicitar el reenvío del XML:</h3>
          </Grid>
          <Grid item xs={12}>
            <FormInputLabel text={"Número de orden"} />
            <TextField
              {...register("orderNumber")}
              type="text"
              margin="dense"
              variant="outlined"
              size="small"
              defaultValue={query.get("order")}
              placeholder="Ejemplo: 0123456"
              fullWidth
            />
            <p className="helperError">{errors.orderNumber?.message}</p>
            <Button
              className="resend-button"
              onClick={handleSubmit(onSubmitHandler)}>
              Enviar Solicitud
            </Button>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default ResendXml;
